export const GET_SERVICE_TYPE_REQUERSTED =
  'GET_SERVICE_TYPE_REQUERSTED'
export const GET_SERVICE_TYPE_SUCCEEDED = 'GET_SERVICE_TYPE_SUCCEEDED'
export const GET_SERVICE_TYPE_FAILED = 'GET_SERVICE_TYPE_FAILED'

export const ADD_SERVICE_TYPE_REQUERSTED =
  'ADD_SERVICE_TYPE_REQUERSTED'
export const ADD_SERVICE_TYPE_SUCCEEDED = 'ADD_SERVICE_TYPE_SUCCEEDED'
export const ADD_SERVICE_TYPE_FAILED = 'ADD_SERVICE_TYPE_FAILED'

export const UPDATE_SERVICE_TYPE_REQUERSTED =
  'UPDATE_SERVICE_TYPE_REQUERSTED'
export const UPDATE_SERVICE_TYPE_SUCCEEDED =
  'UPDATE_SERVICE_TYPE_SUCCEEDED'
export const UPDATE_SERVICE_TYPE_FAILED = 'UPDATE_SERVICE_TYPE_FAILED'

export const CLEAR_SERVICE_TYPES_SUCCEEDED =
  'CLEAR_SERVICE_TYPES_SUCCEEDED'
